import clsx from 'clsx'
import { Container } from '../components/Container'
import { SignupButtonStyled } from './buttons/signup-button'

function CheckIcon({ className }) {
  return (
    <svg className={clsx('h-5 w-5', className)} fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )
}

function Plan({ name, price, description, features, featured }) {
  return (
    <div
      className={clsx(
        'relative flex flex-col rounded-3xl p-8 ring-1',
        featured
          ? 'bg-blue-600 text-white ring-blue-400 shadow-xl scale-105'
          : 'bg-white/5 text-white ring-white/10'
      )}
    >
      {featured && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-white px-4 py-1 text-xs font-semibold text-blue-600">
          Current plan
        </div>
      )}

      <h3 className="text-lg font-semibold">{name}</h3>

      <p className="mt-4 text-4xl font-bold">{price}</p>

      <p className="mt-3 text-sm text-slate-300">{description}</p>

      <ul className="mt-6 space-y-3 text-sm">
        {features.map((feature) => (
          <li key={feature} className="flex items-center">
            <CheckIcon className="text-green-400" />
            <span className="ml-3">{feature}</span>
          </li>
        ))}
      </ul>

      <div className="mt-8">
        <SignupButtonStyled />
      </div>
    </div>
  )
}

export function Pricing() {
  return (
    <section id="pricing" className="bg-slate-900 py-24 sm:py-32">
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-semibold text-white sm:text-5xl">
            Simple pricing while we improve
          </h2>

          <p className="mt-4 text-lg text-slate-400">
            Start free. Help improve the system. Paid plans will follow as accuracy increases.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-md">
          <Plan
            name="Starter"
            price="Free"
            description="Best for testing and early adopters helping train the model."
            featured
            features={[
              'Up to 10 texts per day',
              '~1000 word limit per request',
              'Single text analysis',
              'Basic AI vs human signal output',
              'Text input only',
              '1 user',
            ]}
          />
        </div>

        <div className="mt-12 text-center text-sm text-slate-500">
          More plans (API, bulk uploads, team access) coming soon.
        </div>
      </Container>
    </section>
  )
}